import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-page">
      <h1>Privacy Policy</h1>
      <p className="privacy-last-updated">Last updated: April 2026</p>

      <section>
        <h2>1. Information We Collect</h2>
        <h3>Information You Provide:</h3>
        <ul>
          <li>Email address (for account login)</li>
          <li>Garden photos you upload</li>
          <li>Plant names, notes, and planting dates</li>
          <li>Property information (address, location coordinates)</li>
          <li>Tasks and reminders you create</li>
        </ul>
        <h3>Automatically Collected:</h3>
        <ul>
          <li>Login timestamps and IP addresses</li>
          <li>Device type and operating system</li>
          <li>Usage statistics (which features you use)</li>
        </ul>
        <p className="privacy-note">
          Note: Photos are stripped of metadata including GPS location data before storage. We do not store or use photo location information.
        </p>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To provide the yard tracking service</li>
          <li>To identify plants using AI (PlantNet)</li>
          <li>To provide weather-based recommendations</li>
          <li>To send account-related emails (verification, password reset)</li>
          <li>To improve the service and fix bugs</li>
          <li>To prevent fraud and abuse</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Share Your Information</h2>
        <p><strong>We DO NOT sell your data. Period.</strong></p>
        <h3>We may share data with:</h3>
        <ul>
          <li><strong>PlantNet API:</strong> Photos you submit for identification are sent to PlantNet. See their <a href="https://plantnet.org/en/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a>.</li>
          <li><strong>Weather Services:</strong> Your property coordinates are used to fetch local weather and alerts</li>
          <li><strong>Google Maps:</strong> Property addresses are geocoded to obtain coordinates</li>
          <li><strong>No one else:</strong> Your photos, plants, and yard data remain private</li>
        </ul>
        <h3>Exceptions (Legal Requirements):</h3>
        <ul>
          <li>If required by law or legal process</li>
          <li>To protect our rights or safety</li>
          <li>With your explicit consent</li>
        </ul>
      </section>

      <section>
        <h2>4. Your Data Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li><strong>Access:</strong> View all your data anytime within the app</li>
          <li><strong>Export:</strong> Download your plant data in CSV format</li>
          <li><strong>Delete:</strong> Delete your account and all data (Settings → Manage Account → Delete Account)</li>
          <li><strong>Correct:</strong> Edit or update any information</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>We protect your data with:</p>
        <ul>
          <li><strong>Encryption:</strong> Passwords hashed with bcrypt</li>
          <li><strong>HTTPS:</strong> All data transmitted over secure connections</li>
          <li><strong>Access Controls:</strong> Only you can see your yard data</li>
          <li><strong>Backups:</strong> Daily automated backups</li>
          <li><strong>Photo Privacy:</strong> GPS and metadata stripped from all uploaded photos</li>
        </ul>
        <p>No system is 100% secure. Use a strong password to protect your account.</p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <ul>
          <li>Active accounts: Data retained while your account is active</li>
          <li>Deleted accounts: Data deleted within 30 days of account deletion</li>
          <li>Backups: May retain data in backups for up to 90 days after deletion</li>
          <li>Inactive free accounts: May be removed after 2 years of inactivity with prior email notice</li>
        </ul>
      </section>

      <section>
        <h2>7. Cookies and Local Storage</h2>
        <ul>
          <li><strong>Authentication Tokens:</strong> Used to keep you logged in</li>
          <li><strong>No Tracking:</strong> We don't use advertising or analytics cookies</li>
          <li><strong>Local Storage:</strong> App preferences and chat history stored in your browser only</li>
        </ul>
      </section>

      <section>
        <h2>8. Children's Privacy</h2>
        <ul>
          <li>Service is not intended for users under 18</li>
          <li>We don't knowingly collect data from minors</li>
          <li>If we discover underage users, accounts will be deleted</li>
        </ul>
      </section>

      <section>
        <h2>9. International Users</h2>
        <p>This service is hosted in the United States. By using it, you consent to your data being stored and processed in the US.</p>
      </section>

      <section>
        <h2>10. Changes to This Policy</h2>
        <ul>
          <li>We may update this policy without notice</li>
          <li>Major changes will be emailed to users</li>
          <li>Continued use after changes constitutes acceptance</li>
        </ul>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>Questions about privacy? Contact us at:</p>
        <p><a href="mailto:hello@yardray.app">hello@yardray.app</a></p>
      </section>

      <div className="privacy-commitment">
        <h3>Your Privacy Matters</h3>
        <p style={{ margin: 0 }}>
          We built Yardray because we love our yards too. Your photos and data are yours.
          We're committed to keeping your information private and secure.
        </p>
      </div>
    </div>
  );
}

export default Privacy;